const { isAllowedCountry } = require('utilities/countryProducts');
// @constants
const {
    ASNEF,
    ACCIDENTS_INSURANCE,
    ACCOUNT_DEBITS,
    ADVANCED_ORDER_SPANISH_STOCKS,
    AGGREGATOR,
    AMAZON_GIFT_CARD,
    BRING_MY_FUNDS,
    BIZUM,
    CHAT,
    CHEQUES,
    CREDIT,
    ES_COUNTRY,
    ETFS_DETAILS,
    FUND_GLOSSARY,
    FUNDS_TRANSFER,
    GC,
    INVESTMENTS,
    INVESTMENT_PRODUCTS_LIST,
    JOIN_HOLDERS,
    LOANS_MORTGAGES,
    MIFID,
    NOTIFICATIONS_MANAGEMENT,
    OPENTRADER,
    OPEN_YOUNG,
    PAYROLL_ACCOUNT,
    PFM,
    PROVINCE,
    REFERRALS,
    ROBO,
    SAVINGS,
    SOLIDARITY,
    STOCK_DETAILS,
    TAXATION,
    TOPUP_MOBILE,
    TREND,
    TUTORIAL,
    TYPE_ETFS,
    TYPE_FUNDS,
    TYPE_OF_ROAD,
    TYPE_PLANS,
    TYPE_STOCKS,
    TYPE_WARRANTS,
    WARRANTS_DETAILS,
    DIVERSIFIED_INVESTMENT_FUNDTRANSFER
} = require('constants/flagBasedFeatures');
const { COUNTRIES_CODES: { ES } } = require('constants/countries');
const {
    TYPE_STOCKS: STOCKS,
    TYPE_PLANS: PLANS,
    TYPE_WARRANTS: WARRANTS,
    TYPE_FUNDS: FUNDS,
    TYPE_ETFS: ETFS
} = require('constants/index');

const SIMPLE_COUNTRY_FLAGS = [
    ASNEF,
    ACCIDENTS_INSURANCE,
    ACCOUNT_DEBITS,
    ADVANCED_ORDER_SPANISH_STOCKS,
    AMAZON_GIFT_CARD,
    BRING_MY_FUNDS,
    CHAT,
    CHEQUES,
    CREDIT,
    ETFS_DETAILS,
    FUND_GLOSSARY,
    FUNDS_TRANSFER,
    GC,
    INVESTMENTS,
    JOIN_HOLDERS,
    LOANS_MORTGAGES,
    MIFID,
    NOTIFICATIONS_MANAGEMENT,
    OPENTRADER,
    OPEN_YOUNG,
    PAYROLL_ACCOUNT,
    PFM,
    REFERRALS,
    ROBO,
    SAVINGS,
    SOLIDARITY,
    STOCK_DETAILS,
    TAXATION,
    TREND,
    TOPUP_MOBILE,
    TUTORIAL,
    TYPE_ETFS,
    TYPE_FUNDS,
    TYPE_PLANS,
    TYPE_STOCKS,
    TYPE_WARRANTS,
    WARRANTS_DETAILS,
    TYPE_STOCKS,
    ADVANCED_ORDER_SPANISH_STOCKS
];

const createCountriesSimpleExtraConfig = (flags, originCountry) => {
    return SIMPLE_COUNTRY_FLAGS.reduce((acc, curr) => {
        return {
            ...acc,
            [curr]: isAllowedCountry(flags[`not_allowed_${curr}_countries`], originCountry)
        };
    }, {});
}

const aggregatorFeatureToggling = (flags, originCountry) => {
    return Object.keys(flags).reduce((acc, current) => {
        return acc = {
            ...acc,
            ...(/^agregador-/.test(current)) ? {
                [current]: isAllowedCountry(flags.not_allowed_aggregator_countries, originCountry)
            } : {}
        }
    }, {})
}

const createCountriesExtraConfig = (flags, originCountry) => {
    const aggregatorFlags = aggregatorFeatureToggling(flags, originCountry);
    const isEsCountry = originCountry.toUpperCase() == ES;
    return {
        ...flags,
        ...aggregatorFlags,
        ...createCountriesSimpleExtraConfig(flags, originCountry),
        [AGGREGATOR]: Object.values(aggregatorFlags).some(flag => flag),
        [BIZUM]: isAllowedCountry(flags.not_allowed_bizum_countries, originCountry),
        [CHAT]: isAllowedCountry(flags.not_allowed_chat_countries, originCountry),
        [CHEQUES]: isAllowedCountry(flags.not_allowed_cheques_countries, originCountry),
        [CREDIT]: isAllowedCountry(flags.not_allowed_credit_countries, originCountry),
        [OPEN_YOUNG]: isAllowedCountry(flags.not_allowed_open_young_countries, originCountry),
        [ES_COUNTRY]: isEsCountry,
        [INVESTMENT_PRODUCTS_LIST]: [
            ...isAllowedCountry(flags.not_allowed_type_stocks_countries, originCountry) ? STOCKS : [],
            ...isAllowedCountry(flags.not_allowed_type_funds_countries, originCountry) ? FUNDS : [],
            ...isAllowedCountry(flags.not_allowed_type_plans_countries, originCountry) ? PLANS : [],
            ...isAllowedCountry(flags.not_allowed_type_etfs_countries, originCountry) ? ETFS : [],
            ...isAllowedCountry(flags.not_allowed_type_warrants_countries, originCountry) ? WARRANTS : []
        ],
        [DIVERSIFIED_INVESTMENT_FUNDTRANSFER]: isAllowedCountry(flags.not_allowed_diversified_investment_fundtransfer, originCountry),
        [PAYROLL_ACCOUNT]: isAllowedCountry(flags.not_allowed_payroll_account_countries, originCountry),
        [PROVINCE]: isEsCountry,
        [TYPE_OF_ROAD]: isEsCountry,
    }
}

const createConfig = (flagsObject, originCountry) => {
    for (let flag in flagsObject) {
        if (typeof flagsObject[flag] === 'string') {
            if (flagsObject[flag] === 'true' || flagsObject[flag] === 'false') {
                flagsObject[flag] = flagsObject[flag] === 'true';
            } else if (/^\[(.+)?\]$/.test(flagsObject[flag])) {
                flagsObject[flag] = flagsObject[flag].replace(/\[|\]/g, "").split(',');
            }
        }
    }
    if (originCountry) {
        return createCountriesExtraConfig(flagsObject, originCountry);
    }
    return flagsObject;
}

export { createConfig };
